import { useTranslation } from "@bounce/i18n"

import type { Interpolations } from "../../../Generic/StoreScreen/hooks/useInterpolations"
import type { StoreData } from "@/libs/bounce/stores/types"

import markerImg from "@bounce/assets/big-icons/marker.png"
import starImg from "@bounce/assets/big-icons/star.png"
import headToStoreImg from "@bounce/assets/big-icons/walk.png"

type UseStepsCompactOptions = {
  store: StoreData
  interpolations: Interpolations
}

const useStepsCompact = ({ store, interpolations }: UseStepsCompactOptions) => {
  const { t } = useTranslation("marketing-ls-store")

  // Locker-specific steps
  const lockerSteps = [
    {
      src: markerImg,
      title: t("screen.storeScreen.stepsCompact.stepOneTitle", "Book bag storage in a tap"),
      description: t(
        "screen.storeScreen.stepsCompact.stepOneDescription",
        "Choose how long you need luggage storage and book online.",
      ),
    },
    {
      src: headToStoreImg,
      title: t("screen.storeScreen.stepsCompact.stepTwoTitleLocker", "Go to {STORE_NAME}", interpolations),
      description: t(
        "screen.storeScreen.stepsCompact.step2DescriptionLocker",
        "Drop off your bags at the locker using the Bounce app.",
      ),
    },
    {
      src: starImg,
      title: t(
        "screen.storeScreen.stepsCompact.stepThreeTitleV2",
        "Enjoy your day exploring {FEATURED_POI_NAME}",
        interpolations,
      ),
      description: t(
        "screen.storeScreen.stepsCompact.step3DescriptionLocker",
        "Do whatever you’d like, then pickup your bags when you are ready.",
      ),
    },
  ]

  // Default steps
  const defaultSteps = [
    {
      src: markerImg,
      title: t("screen.storeScreen.stepsCompact.stepOneTitle", "Book bag storage in a tap"),
      description: t(
        "screen.storeScreen.stepsCompact.stepOneDescription",
        "Choose how long you need luggage storage and book online.",
      ),
    },
    {
      src: headToStoreImg,
      title: t("screen.storeScreen.stepsCompact.stepTwoTitleV3", "Go to the Bounce Partner location", interpolations),
      description: t(
        "screen.storeScreen.stepsCompact.step2Description",
        "Drop off your bags by showing your confirmation to a store employee.",
      ),
    },
    {
      src: starImg,
      title: t(
        "screen.storeScreen.stepsCompact.stepThreeTitleV2",
        "Enjoy your day exploring {FEATURED_POI_NAME}",
        interpolations,
      ),
      description: t(
        "screen.storeScreen.stepsCompact.step3Description",
        "Do whatever you’d like, then show your confirmation to pick up your stuff.",
      ),
    },
  ]

  if (store.type === "Locker") {
    return lockerSteps
  }
  return defaultSteps
}

export default useStepsCompact
